module.exports = __webpack_public_path__ + "static/media/PCMarkAsReadIcon.ae8687a6.svg";